<template>
    <kr_popup_change @successReservation="getReservationList" ref="popupChange"/>
    <ul class="mypage-main">
        <li class="mypage-main__item item1">
            <h3 class="title02">
                {{myInfo.name}} <span class="title03">님</span>
            </h3>
            <div class="mypage-main__item__con">
                <div class="mypage-main--number" v-if="$commonUtils.isNotEmpty(myInfo.ptNo)">
                    <p class="text">환자등록번호<b>{{myInfo.ptNo}}</b></p>
                </div>
                <div class="botton-wrap">
                    <!-- 수정필요(퍼블리싱) -->
                    <a href="javascript:;" class="sub-button c-main" v-if="$commonUtils.isEmpty(myInfo.ptNo)" @click="showPopup">환자번호 조회</a>
                    <router-link to="/kr/mypage/member/updateMember" class="sub-button c-main">회원정보수정</router-link>
                </div>
            </div>
        </li>
        <li class="mypage-main__item item2">
            <h3 class="title02">나의 예약 일정</h3>

            <!-- 수정필요(퍼블리싱) -->
            <div class="mypage-main__item__con" v-if="reservationList.length === 0">
                <p>예약된 진료일정이 없습니다.</p>
            </div>
            <template v-if="reservationList.length > 0">
                <div class="mypage-main__item__con">
                    <div class="mypage-main__doctor">
                        <div class="mypage-main__doctor--img">
                            <img :src="`/displayFile.do?attachNo=${ reservationList[0].doctorInfo.attachBag.thumbs[0].attachNo }`" :alt="reservationList[0].doctorInfo.attachBag.thumbs[0].altValue || '이미지'" v-if="reservationList[0].doctorInfo.attachBag.thumbs">
                        </div>
                        <div class="mypage-main__doctor--con">
                            <p class="font-sub title03"><b>{{ formatFullDate(reservationList[0].MED_DT) }} {{formatTime(reservationList[0].MED_DTM)}}</b></p>
                            <p>[{{reservationList[0].doctorInfo.deptNm}}] {{ reservationList[0].MED_NM }}교수</p>
                        </div>
                    </div>
                    <div class="botton-wrap nowrap">
                        <a href="javascript:;" class="sub-button c-main" @click="changeReservation">예약변경</a>
                        <a href="javascript:;" class="sub-button c-gray" @click="CancelReservation">예약취소</a>
                    </div>
                </div>
            </template>
        </li>
        <li class="mypage-main__item item3">
            <h3 class="title02">작성글</h3>
            <div class="mypage-main__item__con">
                <ul class="mypage-main__item3__list">
                    <li class="mypage-main__item3__item">
                        <router-link to="/kr/mypage/board/myThanks" class="">
                            <div class="num">
                                <div class="num__inner"><b>{{thanksCnt}}</b> 건 </div>
                            </div>
                            <p class="tit">고맙습니다</p>
                        </router-link>
                    </li>
                    <li class="mypage-main__item3__item">
                        <router-link to="/kr/mypage/board/myTendinous" class="">
                            <div class="num">
                                <div class="num__inner"><b>{{tendinousCnt}}</b> 건 </div>
                            </div>
                            <p class="tit">건의합니다</p>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li class="mypage-main__item item4">
            <div class="mypage-main__title">
                <router-link to="/kr/mypage/reservation/selectReservation">
                    <h3 class="title02">예약 확인</h3>
                </router-link>
                <router-link to="/kr/mypage/reservation/selectReservation" class="mypage-main__title--arrow"></router-link>
            </div>
            <div class="mypage-main__item__con">
                <div class="mypage-main__item4__list-wrap">
                    <ul class="mypage-main__item4__list">
                    <!-- 수정필요(퍼블리싱) -->
                        <p v-if="reservationList.length === 0">예약된 진료일정이 없습니다.</p>
                        <li v-for="(item, index) in reservationList">
                            <a href="javascript:;">
                                <h3 class="title02">{{formatDate(item.MED_DT)}}</h3>
                                <h4 class="title03">{{formatTime(item.MED_DTM)}}</h4>
                                <p>[{{item.doctorInfo.deptNm}}] {{ item.MED_NM }}교수</p>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </li>
        <li class="mypage-main__item item5">
            <h3 class="title02">결과 조회</h3>
            <div class="mypage-main__item__con">
                <ul class="mypage-main__item5__list">
                    <li class="mypage-main__item5__item">
                        <router-link to="/kr/mypage/result/out" class="">
                            <div class="icon">
                                <img src="@/assets/resource/icon/mypage-main__item5-icon01.svg" alt="">
                            </div>
                            <p class="title02">외래진료 내역</p>
                        </router-link>
                    </li>
                    <!-- <li class="mypage-main__item5__item">
                        <router-link to="/kr/mypage/result/drug" class="">
                            <div class="icon">
                                <img src="@/assets/resource/icon/mypage-main__item5-icon02.svg" alt="">
                            </div>
                            <p class="title02">약 처방 내역</p>
                        </router-link>
                    </li> -->
                    <li class="mypage-main__item5__item">
                        <router-link to="/kr/mypage/result/check" class="">
                            <div class="icon">
                                <img src="@/assets/resource/icon/mypage-main__item5-icon03.svg" alt="">
                            </div>
                            <p class="title02">{{$store.getters.getHost == 'H0008' ? '검사결과' : '검사 내역 조회'}}</p>
                        </router-link>
                    </li>
                </ul>
            </div>
        </li>
        <li class="mypage-main__item item6" v-if="$store.getters.getHost == 'H0006'">
            <div class="mypage-main__title">
                <router-link to="/kr/mypage/health/bloodMain">
                    <h3 class="title02">혈압 수첩</h3>
                </router-link>
                <router-link to="/kr/mypage/health/bloodMain" class="mypage-main__title--arrow"></router-link>
            </div>
            <div class="mypage-main__item__con">
                <ul class="mypage-main__item6__list">
                    <li class="mypage-main__item6__item">
                        <h4 class="title02">혈압</h4>
                        <div class="cont">
                            <div class="img">
                                <img src="@/assets/resource/icon/mypage-main__item6-icon01.svg" alt="">
                            </div>
                            <div class="text" v-if="healthRecord.BP">
                                <p><b class="title02">{{healthRecord.BP.record2}}~{{healthRecord.BP.record1}}</b> mmHg</p>
                                <p><b>{{calcBP(healthRecord.BP)}}</b></p>
                            </div>
                            <div class="text" v-if="healthRecord.BP == null">
                                <p>등록된 데이터가 없습니다</p>
                                <div class="botton-wrap">
                                    <router-link to="/kr/mypage/health/bloodPressure" class="main-button small c-gray">혈압 등록</router-link>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="mypage-main__item6__item">
                        <h4 class="title02">혈당</h4>
                        <div class="cont">
                            <div class="img">
                                <img src="@/assets/resource/icon/mypage-main__item6-icon02.svg" alt="">
                            </div>
                            <div class="text" v-if="healthRecord.BS">
                                <p><b class="title02">{{healthRecord.BS.record2}}</b> mg/dl</p>
                                <p><b>{{calcBS(healthRecord.BS)}}</b></p>
                            </div>
                            <div class="text" v-if="healthRecord.BS == null">
                                <p>등록된 데이터가 없습니다</p>
                                <div class="botton-wrap">
                                    <router-link to="/kr/mypage/health/bloodSugar" class="main-button small c-gray">혈당 등록</router-link>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="mypage-main__item6__item">
                        <h4 class="title02">체질량</h4>
                        <div class="cont">
                            <div class="img">
                                <img src="@/assets/resource/icon/mypage-main__item6-icon03.svg" alt="">
                            </div>
                            <div class="text" v-if="healthRecord.BM">
                                <p><b class="title02">{{healthRecord.BM.record1}}</b> cm/<b class="title02">{{healthRecord.BM.record2}}</b> kg</p>
                                <p><b>{{calcBMI(healthRecord.BM)}}</b></p>
                            </div>
                            <div class="text" v-if="healthRecord.BM == null">
                                <p>등록된 데이터가 없습니다</p>
                                <div class="botton-wrap">
                                    <router-link to="/kr/mypage/health/bodyMass" class="main-button small c-gray">체질량 등록</router-link>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </li>
        <li class="mypage-main__item item6" v-if="$store.getters.getHost == 'H0007'">
            <div class="mypage-main__title">
                <router-link to="/kr/mypage/health/bloodMain">
                    <h3 class="title02">혈압 수첩</h3>
                </router-link>
                <router-link to="/kr/mypage/health/bloodMain" class="mypage-main__title--arrow"></router-link>
            </div>
            <div class="mypage-main__item__con">
                <ul class="mypage-main__item6__list">
                    <li class="mypage-main__item6__item">
                        <h4 class="title02">혈압</h4>
                        <div class="cont">
                            <div class="img">
                                <img src="@/assets/resource/icon/mypage-main__item6-icon01-brain.png" alt="">
                            </div>
                            <div class="text" v-if="healthRecord.BP">
                                <p><b class="title02">{{healthRecord.BP.record2}}~{{healthRecord.BP.record1}}</b> mmHg</p>
                                <p><b>{{calcBP(healthRecord.BP)}}</b></p>
                            </div>
                            <div class="text" v-if="healthRecord.BP == null">
                                <p>등록된 데이터가 없습니다</p>
                                <div class="botton-wrap">
                                    <router-link to="/kr/mypage/health/bloodPressure" class="main-button small c-gray">혈압 등록</router-link>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="mypage-main__item6__item">
                        <h4 class="title02">혈당</h4>
                        <div class="cont">
                            <div class="img">
                                <img src="@/assets/resource/icon/mypage-main__item6-icon02-brain.png" alt="">
                            </div>
                            <div class="text" v-if="healthRecord.BS">
                                <p><b class="title02">{{healthRecord.BS.record2}}</b> mg/dl</p>
                                <p><b>{{calcBS(healthRecord.BS)}}</b></p>
                            </div>
                            <div class="text" v-if="healthRecord.BS == null">
                                <p>등록된 데이터가 없습니다</p>
                                <div class="botton-wrap">
                                    <router-link to="/kr/mypage/health/bloodSugar" class="main-button small c-gray">혈당 등록</router-link>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="mypage-main__item6__item">
                        <h4 class="title02">체질량</h4>
                        <div class="cont">
                            <div class="img">
                                <img src="@/assets/resource/icon/mypage-main__item6-icon03-brain.png" alt="">
                            </div>
                            <div class="text" v-if="healthRecord.BM">
                                <p><b class="title02">{{healthRecord.BM.record1}}</b> cm/<b class="title02">{{healthRecord.BM.record2}}</b> kg</p>
                                <p><b>{{calcBMI(healthRecord.BM)}}</b></p>
                            </div>
                            <div class="text" v-if="healthRecord.BM == null">
                                <p>등록된 데이터가 없습니다</p>
                                <div class="botton-wrap">
                                    <router-link to="/kr/mypage/health/bodyMass" class="main-button small c-gray">체질량 등록</router-link>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </li>
        <li class="mypage-main__item item9" v-if="$store.getters.getHost == 'H0007'">
            <div class="mypage-main__title">
                <router-link to="/kr/mypage/headNote/headNote">
                    <h3 class="title02">두통 수첩</h3>
                </router-link>
                <router-link to="/kr/mypage/headNote/headNote" class="mypage-main__title--arrow"></router-link>
            </div>
            <div class="mypage-main__item__con">
                <div class="mypage-main__baby">
                    <div class="img">
                        <img src="/resource/icon/mypage-main__brain.png" alt="">
                    </div>
                    <div class="cont">
                        <template v-if="headNote">
                            <p v-if="headNote.painStartTime">
                                {{ $commonUtils.makeDateFormat(headNote.painDate, '.') }}   
                                {{ headNote.painStartTime.slice(0,2) + ':' + headNote.painStartTime.slice(2) }} ~
                                {{ headNote.painEndTime.slice(0,2) + ':' + headNote.painEndTime.slice(2) }}
                            </p>
                            <h3 class="font-main title02">{{ headNote.painLevel }} / 10</h3>
                        </template>
                        <p v-else>
                            두통 수첩 에서 <br>
                            정보를 등록해주세요.
                        </p>
                    </div>
                </div>
            </div>
        </li>
        <li class="mypage-main__mom" v-if="$store.getters.getHost == 'H0008'">
            <div class="mypage-main__item item9">
                <div class="mypage-main__title">
                    <router-link to="/kr/mypage/babyNote/babyNoteMain">
                        <h3 class="title02">엄마아기수첩</h3>
                    </router-link>
                    <router-link to="/kr/mypage/babyNote/babyNoteMain" class="mypage-main__title--arrow"></router-link>
                </div>
                <div class="mypage-main__item__con">
                    <div class="mypage-main__baby">
                        <div class="img">
                            <img src="/resource/icon/mypage-main__baby.svg" alt="" v-if="familyList.length > 0">
                        </div>
                        <div class="cont">
                            <template v-if="familyList.length > 0">
                                <sub>엄마와 아기의 280일간의 이야기</sub>
                                <p>{{familyList[0].baby1}}와 만나기까지</p>
                                <h3 class="font-main title02">{{getWeekDate(familyList[0].expectedDt)}}</h3>
                            </template>
                            <p v-else>
                                엄마아기수첩 에서 <br>
                                정보를 등록해주세요.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mypage-main__item item7">
                <h3 class="title02">즐겨찾기</h3>
                <div class="mypage-main__item__con">
                    <div class="botton-wrap nowrap">
                        <router-link to="/kr/mypage/favo/favoDoctors" class="main-button c-main">관심 의료진</router-link>
                        <router-link to="/kr/mypage/favo/favoContents" class="main-button c-sub">관심 콘텐츠</router-link>
                    </div>
                </div>
            </div>
        </li>
        <li class="mypage-main__mom" v-if="$store.getters.getHost == 'H0009'">
            <div class="mypage-main__item item7">
                <h3 class="title02">즐겨찾기</h3>
                <div class="mypage-main__item__con">
                    <div class="botton-wrap nowrap">
                        <router-link to="/kr/mypage/favo/favoDoctors" class="main-button c-main">관심 의료진</router-link>
                        <router-link to="/kr/mypage/favo/favoContents" class="main-button c-sub">관심 콘텐츠</router-link>
                    </div>
                </div>
            </div>
            <div class="mypage-main__item item8">
                <div class="mypage-main__title">
                    <a href="https://www.eumc.ac.kr/fund/join/write.do" target="_blank">
                        <h3 class="title02">후원하기</h3>
                    </a>
                    <a href="https://www.eumc.ac.kr/fund/join/write.do" target="_blank" class="mypage-main__title--arrow"></a>
                </div>
            </div>
        </li>
        <li class="mypage-main__item item7" v-if="$store.getters.getHost != 'H0008' && $store.getters.getHost != 'H0009'">
            <h3 class="title02">즐겨찾기</h3>
            <div class="mypage-main__item__con">
                <div class="botton-wrap nowrap">
                    <router-link to="/kr/mypage/favo/favoDoctors" class="main-button c-main">관심 의료진</router-link>
                    <router-link to="/kr/mypage/favo/favoContents" class="main-button c-sub">관심 콘텐츠</router-link>
                </div>
            </div>
        </li>
        <li class="mypage-main__item item8" v-if="$store.getters.getHost != 'H0009'">
            <div class="mypage-main__title">
                <a href="https://www.eumc.ac.kr/fund/join/write.do" target="_blank">
                    <h3 class="title02">후원하기</h3>
                </a>
                <a href="https://www.eumc.ac.kr/fund/join/write.do" target="_blank" class="mypage-main__title--arrow"></a>
            </div>
        </li>
        <li class="mypage-main__item item8" v-if="$store.getters.getHost == 'H0008'">
            <div class="mypage-main__title">
                <router-link to="/kr/mypage/member/outMember">
                    <h3 class="title02">회원탈퇴</h3>
                </router-link>
                <router-link to="kr/mypage/member/outMember" class="mypage-main__title--arrow"></router-link>
            </div>
        </li>
    </ul>
    <kr_popup_certification v-if="popupVisible" @cancelNameCheck="hidePopup"/>
</template>

<script>
export default {
    name: "mypage",
    data() {
        return {
            myInfo: this.$store.state.myInfoStore,
            today: '',
            nextYear: '',
            dataList: [],
            reservationList: [],
            thanksCnt: 0,
            tendinousCnt: 0,
            healthRecord: {BP:{},BS:{},BM:{}},
            popupVisible: false,

            familyList: [],
            headNote: {},
        };
    },
    methods: {
        getWeekDate(targetDateStr) {
            const targetDate = new Date(targetDateStr);

            const dateMinus280 = new Date(targetDate.getTime() - 280 * 24 * 60 * 60 * 1000);

            const currentDate = new Date();
            currentDate.setHours(0, 0, 0, 0);

            // 날짜 차이 계산 (밀리초 단위로 차이 계산)
            const deltaMilliseconds = currentDate - dateMinus280;

            // 밀리초를 일수로 변환 (1일 = 24시간 * 60분 * 60초 * 1000밀리초)
            const deltaDays = Math.floor(deltaMilliseconds / (24 * 60 * 60 * 1000));

            const weeks = Math.floor(deltaDays / 7);
            const days = deltaDays % 7;

            return weeks + '주' + days + '일차'
        },
        getFamily(){
            this.axios.get(this.api.mypage.familyList)
            .then((res) => {
                this.familyList = res.data.result.list
            })
        },
        showPopup() {
            this.popupVisible = true;
        },
        hidePopup() {
            this.popupVisible = false;
        },
        async getReservationList() {
            //YYYYMMDD 형식으로 현재일, 1년 뒤 날짜를 구해서 API 호출
            let today = new Date();
            // const inApyDt = today.toISOString().slice(0, 10).replace(/-/g, '');
            const inApyDt = this.$commonUtils.addDate("d", 2, this.$commonUtils.getToday())

            let twoMonthLater = new Date(today.setMonth(today.getMonth() + 12));
            const inEndDt = twoMonthLater.toISOString().slice(0, 10).replace(/-/g, '');

            try {
                this.reservationList = []
                const response = await this.axios.get(this.api.mypage.reservationList, {
                    params: {
                        IN_APCN_YN: 'A',
                        IN_APY_DT: inApyDt,
                        IN_END_DT: inEndDt,
                        hospId: this.$store.getters.getHost
                    }
                });
                for (let i of response.data.list) {
                    let doc = response.data.doclist.find((val) => i.MEDR_SID == val.drSid)
                    i.doctorInfo = doc;
                    this.reservationList.push(i);
                }
                // this.reservationList.sort(function(a, b) {
                //     return a.MED_DT - b.MED_DT;
                // })
                this.reservationList.sort((a, b) => new Date(a.MED_DT) - new Date(b.MED_DT));
                //this.dataList = response.data
            } catch (err) {
                console.error(err);
            }
        },
        formatFullDate(param) {
            if(!param) return ''
            
            const date = new Date(param);

            const weekDays = ['일', '월', '화', '수', '목', '금', '토'];
            const weekDay = weekDays[date.getDay()];

            return `${param} (${weekDay})`;
        },
        formatDate(param) {
            if(!param) return ''

            const date = new Date(param);

            const month = date.getMonth() + 1;
            const day = date.getDate();
            const weekDays = ['일', '월', '화', '수', '목', '금', '토'];
            const weekDay = weekDays[date.getDay()];

            return `${month}월 ${day}일 (${weekDay})`;
        },
        formatTime(timeString) {
            const hours = timeString.slice(0, 2);
            const minutes = timeString.slice(2, 4);

            return `${hours}:${minutes}`;
        },
        getMainInfo(){
            this.axios({
                method:"get",
                url: this.api.mypage.mainInfo,
                params: {
                    'tendinousNo' : 11,
                    'thanksNo' : 10
                }
            }).then(response => {
                console.log("response: " + JSON.stringify(response));

                this.thanksCnt = response.data.thanksCnt;
                this.tendinousCnt = response.data.tendinousCnt;
                this.healthRecord.BP = response.data.healthRecordBP;
                this.healthRecord.BS = response.data.healthRecordBS;
                this.healthRecord.BM = response.data.healthRecordBM;
            });
        },
        calcBMI(bm){
            const bmi = (bm.record2 / ((bm.record1 / 100) * (bm.record1 / 100))).toFixed(2);
            let result = '';
            if(bmi < 18.5){
                result = '저체중';
            }else if(bmi >= 18.5 && bmi < 23){
                result = '정상';
            }else if(bmi >= 23 && bmi < 25){
                result = '과체중';
            }else if(bmi >= 25 && bmi < 30){
                result = '비만';
            }else{
                result = '고도비만';
            }

            return result;

        },
        calcBS(bs){
            let result = '';
            if(bs.record1 == '식전'){
                if(bs.record2 < 70){
                    result = '저혈당';
                }else if(bs.record2 >= 70 && bs.record2 <= 100){
                    result = '정상';
                }else if(bs.record2 > 100 && bs.record2 <= 124){
                    result = '조절필요';
                }else{
                    result = '관리필요';
                }
            }else{
                if(bs.record2 < 70){
                    result = '저혈당';
                }else if(bs.record2 >= 70 && bs.record2 <= 140){
                    result = '정상';
                }else if(bs.record2 > 140 && bs.record2 <= 200){
                    result = '조절필요';
                }else{
                    result = '관리필요';
                }
            }

            return result;
        },
        calcBP(bp){
            let result = '';
            if(bp.record1 <= 90){
                result = '저혈압';
            }else if(bp.record1 < 120 && bp.record2 < 90){
                result = '정상';
            }else if(bp.record1 >= 120 && bp.record1 < 140){
                result = '전고혈압';
            }else if(bp.record1 >= 140 && bp.record1 < 160){
                result = '1기고혈압';
            }else{
                result = '2기고혈압';
            }

            return result;
        },
        checkNameCert(url){
            if(!this.$store.state.myInfoStore) {
                alert('실명인증을 해주시길 바랍니다.')
                return
            }
            this.$router.push(url)
        },
        changeReservation() {
            const info = this.reservationList[0].doctorInfo
            info.RPY_PACT_ID = this.reservationList[0].RPY_PACT_ID
            info.mainDeptCd = this.reservationList[0].MED_DEPT_CD
            this.$refs.popupChange.info = info
            this.$refs.popupChange.popupBtn()
        },
        CancelReservation(){
            if (confirm('예약을 취소하시겠습니까?')) {
                const item = this.reservationList[0]
                const param = {
                    IN_PACT_ID : item.RPY_PACT_ID,
                    IN_MED_DEPT_CD : item.MED_DEPT_CD,
                }

                this.axios({
                    method: 'post',
                    url: this.api.mypage.reservationCancel,
                    params: param
                }).then(res => {
                    if(res.data.errormsg){
                        alert(res.data.errormsg)
                        return
                    }
                    alert('예약이 취소되었습니다.')
                    this.getReservationList()
                }).catch(err => {
                    alert('오류가 발생했습니다.')
                    location.reload(true);
                })
            }
        },
        checkSuccess(data){
            if(data.iReturn === 0 && data.ptNo !== '' && data.ptNo !== null){
                this.hidePopup()
                const ptNo = data.ptNo

                this.myInfo.ptNo =  ptNo
                this.$store.state.myInfoStore.ptNo = ptNo
            }else{
                alert(data.sMessage)
            }
        },
    },
    async mounted() {
        this.getMainInfo();
        if(this.$store.getters.getHost == 'H0008') this.getFamily()
        this.getReservationList();

        window.addEventListener("message", (event) => {
            try {
                if (event.data && event.data.source === "react-devtools-content-script") {
                    return;
                }

                const receivedData = JSON.parse(event.data); // JSON 파싱
                if (receivedData.callFunction === "checkSuccess") {
                    this.checkSuccess(receivedData.data); // 데이터 전달
                }
            } catch (e) {
                console.error("Invalid JSON data received:", e);
            }
        });

        this.axios.get(this.api.mypage.headNoteNewOne)
            .then(response => {
                this.headNote = response.data
            });

    },
};
</script>

<style scoped></style>